import {
  getEnrollmentStatusRequest,
  getRestartVerificationRequest,
} from './requestCreator';
import { getRequest, postRequest } from './AxiosClient';
// import { militaryEnrolled, notEnrolled, notEnrolledOrFailedWithID } from './mock-data';

// Use this function for mock data
// export async function getEnrollmentStatus(channel) {
//   const response = {
//     data: {
//       militaryDiscount: {
//         ...militaryEnrolled
//       }
//     }
//   };
//   return Promise.resolve({ response });
// }

export const getEnrollmentStatus = async (channel) => {
  const { url, headers } = getEnrollmentStatusRequest(channel);
  return getRequest(url, headers).then((response, error) => {
    // eslint-disable-next-line eqeqeq
    if (response?.status == 200
      && typeof response.data === 'object'
      && response?.data?.militaryDiscount) return { response, error: null };
    return { error, response: null };
  }).catch((error) => {
    // eslint-disable-next-line no-console
    console.log('Error calling enrollment API, in getEnrollmentStatus()');
    return { error, response: null };
  });
};

export const restartVerification = async (channel) => {
  const { url, headers } = getRestartVerificationRequest(channel);
  return postRequest(url, headers).then((response) => {
    // eslint-disable-next-line eqeqeq
    if (response?.status == 200
      && typeof response.data === 'object'
      && response?.data?.militaryDiscount) return { response };
    return { error: true };
  }).catch((error) => {
    // eslint-disable-next-line no-console
    console.log('Error calling restart verification API, in restartVerification()');
    return { error: true };
  });
};
